// PAY.JP の flow を作成

import apiFactory from '../api-factory'

const V2_BASE_URL = process.env.VUE_APP_API_V2_BRIDGE_BASE_URL || '/api/v2-bridge'

// body = { saleId: number }

export default apiFactory({
  path: `${V2_BASE_URL}/payments/payjp/flows`,
  method: 'POST',
  needAuth: true,
})
